import { trackEvents } from '@/utils/analytics';

export const ELIGIBILITY_CHECK_GTM_EVENT = {
  SUBMITTED: 'eligibility_check_submitted',
  RESULT: 'eligibility_check_result',
  ERROR: 'eligibility_check_error',
} as const;

export type EligibilityCheckErrorType = 'validation' | 'service';

export function trackEligibilityCheckSubmitted({
  zip,
  state,
}: {
  zip: string;
  state: string;
}) {
  trackEvents({ event: ELIGIBILITY_CHECK_GTM_EVENT.SUBMITTED, zip, state });
}

export function trackEligibilityCheckResult({
  zip,
  isInService,
}: {
  zip: string;
  isInService: boolean;
}) {
  trackEvents({
    event: ELIGIBILITY_CHECK_GTM_EVENT.RESULT,
    zip,
    is_in_service: isInService,
  });
}

export function trackEligibilityCheckError(
  errorType: EligibilityCheckErrorType
) {
  trackEvents({
    event: ELIGIBILITY_CHECK_GTM_EVENT.ERROR,
    error_type: errorType,
  });
}
